import { Form } from '@unform/web';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: grid;

  width: 100%;

  height: 40rem;

  min-height: 30%;

  /* grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 1rem;

  > div:not(:nth-child(1)):not(:nth-child(2)):not(:nth-child(3)):not(:nth-child(4)) {
    margin-top: 1rem;
  }

  @media (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);

    > div:not(:nth-child(1)):not(:nth-child(2)):not(:nth-child(3)) {
      margin-top: 1rem;
    }
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);

    > div:not(:nth-child(1)):not(:nth-child(2)) {
      margin-top: 1rem;
    }
  }

  @media (max-width: 425px) {
    grid-template-columns: repeat(1, 1fr);

    min-width: calc(100vw - 5.5rem);

    > div:not(:nth-child(1)) {
      margin-top: 1rem;
    }
  } */
`;

export const FormWrapper = styled(Form)`
  /* width: 80rem; */
  width: 100%;

  flex: 1;
  display: flex;
  flex-direction: row;

  > div:not(:last-child) {
    margin-bottom: 10rem;
  }

  p.Mui-error {
    margin: 0rem;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem 0 0 0;
  margin: 1rem;
  width: 100%;
  align-content: center;
  align-self: center;

  button {
    margin-top: 1rem;
  }
`;
